var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mz-grid-item",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":function($event){return _vm.trackClick(_vm.item, _vm.index)}}})}
var staticRenderFns = []

export { render, staticRenderFns }